import * as uuid from "uuid";

import { Guid } from "@/Common/Models/Guid";

/**
 * Simplifies working with .NET-style unique identifiers.
 */
class GuidHelper {
    /**
     * Mark a string value as a GUID **without validating that it's a valid GUID value**.
     * @param value The string value to treat as a GUID without validation.
     */
    public static AsGuid(value: string): Guid {
        return value as Guid;
    }

    /**
     * Generate a random GUID.
     */
    public static NewGuid(): Guid {
        return GuidHelper.AsGuid(uuid.v4());
    }

    /**
     * Get the value representing an empty GUID.
     * @returns The GUID empty value "00000000-0000-0000-0000-000000000000".
     */
    public static Empty(): Guid {
        return GuidHelper.AsGuid(uuid.NIL);
    }

    /**
     * Get whether a given GUID value is null, empty, or equal to {@link Empty}.
     * @param id The GUID value to check.
     */
    public static IsNullOrEmpty(id: Guid | string): boolean {
        return !id || id === uuid.NIL;
    }
}

export { GuidHelper };
